export default "__VITE_ASSET__B9Ygz2kP__"